// Main menu

import $ from 'jquery';
import slick from 'slick-slider'

$('.open-menu').click(function() {
    $('.main-menu').show();
});

$('.exit-menu').click(function() {
    $('.main-menu').hide();
});

$('.mega-menu > a').click(function(e) {
    e.preventDefault();
    $(this).next().toggle();
    $(this).toggleClass('active')
});

// Video

// Generating thumbnail

$('.video').each(function() {
    const iframe = $(this).find('iframe');
    const iframe_src = iframe.attr('src');
    const youtube_video_id = iframe_src.match(/youtube\.com.*(\?v=|\/embed\/)(.{11})/).pop();
    const video_thumbnail = $('<img src="//img.youtube.com/vi/' + youtube_video_id + '/mqdefault.jpg" alt="Video thumbnail" class="thumb">');
    $(this).children('.thumbnail').append(video_thumbnail);
})

// Overlaying and hiding video

$('.video .thumbnail').click(function() {
    $(this).siblings('.video-overlay').css('display', 'flex');
});

$('.video-overlay').click(function() {
    const video = $(this).children('iframe');
    video.attr('src', video.attr('src'));
    $(this).hide();
});

// Canterbury map

// Hovering and clicking

const map = $('.map');
const regions = $('.map path');
const labels = $('.map p');
const districts = $('.districts a');

// Highlight regions
for (let i = 0; i < regions.length; i++) {
    const region = $(regions[i]);
    const label = $(labels[i]);

    region.add(label).on('click mouseover mouseleave', function() {
        region.toggleClass('active');
        label.toggleClass('active');

        const districtIndexes = getDistrictsFromRegion(i);
        for (let j = 0; j < districtIndexes.length; j++) {
            const districtIndex = districtIndexes[j];
            $(districts[districtIndex]).toggleClass('active');
        }
    });

    region.add(label).click(function() {
        window.location = districts[getDistrictsFromRegion(i)[0]];
    });
}

// Highlight districts
for (let i = 0; i < districts.length; i++) {
    const district = $(districts[i]);

    district.on('click mouseover mouseleave', function() {
        district.toggleClass('active');

        const regionIndexes = getRegionsFromDistrict(i);
        for (let j = 0; j < regionIndexes.length; j++) {
            const regionIndex = regionIndexes[j];
            $(regions[regionIndex]).toggleClass('active');
            $(labels[regionIndex]).toggleClass('active');
        }
    });
}

// Used to highlight regions when hovered over district
function getRegionsFromDistrict(districtIndex) {
    switch (districtIndex) {
        case 0: // Christchurch Metro Cricket
        case 1: // Christchurch Junior Cricket
            return [2];
        case 2: // Canterbury Country Cricket
            return [3, 4, 5, 6];
        case 3: //Buller Cricket
            return [0];
        case 4: //Mid Canterbury Cricket
            return [7];
        case 5: //South Canterbury Cricket
            return [8];
        default: //West Coast Cricket
            return [1];
    }
}

// Used to highlight districts when hovered over region
function getDistrictsFromRegion(regionIndex) {
    switch (regionIndex) {
        case 0: // Buller
            return [3];
        case 1: // West Coast
            return [6];
        case 2: // Christchurch
            return [0, 1];
        case 3: // Kaikoura
        case 4: // Hurunui
        case 5: // Waimakariri
        case 6: // Selwyn
            return [2];
        case 7: // Ashburton
            return [4];
        default: // Timaru
            return [5];
    }
}

// Label scaling

$(window).on('load resize', function() {
    let scale = 12 * map.width() / 494;
    labels.css('font-size', scale);
})

// Footer

// Scroll to top

function scrollToTop() {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
}

// Search bar

$('.clear-search').click(function() {
    $('.search-bar .query').val('');
});

$('.search-bar').submit(function() {
    if (!$('.search-bar .query').val()) {
        $('.search-bar .programme').val('');
    }
});

// Banner images

$('.banner').slick({
    prevArrow: $('.banner-back'),
    nextArrow: $('.banner-forward'),
});
